import { createSelector } from 'reselect';
import { prop } from 'ramda';
import { selectIsOverlayOpen } from '../overlay';

export const selectAuthDomain = prop('auth');

export const selectUserData = createSelector(
  selectAuthDomain,
  prop('data')
);

export const selectUserId = createSelector(
  selectUserData,
  prop('uid')
);

export const selectIsModalVisible = createSelector(
  selectAuthDomain,
  selectIsOverlayOpen,
  (authDomain, isOtherOverlayOpen) => (isOtherOverlayOpen ? null : prop('activeModal', authDomain))
);

export const selectIsAuthenticated = createSelector(
  selectAuthDomain,
  prop('isAuthenticated')
);

export const selectIsAnonymous = createSelector(
  selectUserData,
  prop('isAnonymous')
);

export const selectIsSignedIn = createSelector(
  selectIsAuthenticated,
  selectIsAnonymous,
  (isAuthenticated, isAnonymous) => isAuthenticated && !isAnonymous
);

export const selectAuthModeParams = createSelector(
  selectAuthDomain,
  prop('authModeParams')
);

export const selectAuthAttempts = createSelector(
  selectAuthDomain,
  prop('authAttempts')
);
